import { createSelector } from 'reselect';
import { BaseState } from '../../../entities/BaseState';
import { HubConnectionState } from '../entities';

const getHubConnection = (state: BaseState) => state.hubConnection;

const getDeviceTabId = createSelector(
	[getHubConnection],
	(hubConnection: HubConnectionState): string => hubConnection.deviceTabId
);

export default getDeviceTabId;
